

import React from 'react'
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'shards-react'
import SSOSteps from "../../../../assets/img/homepage/ssoSteps.png"
const SSORemovelModal = ({closeModal}) => {
    return (

  <Modal
      className='col-md-8 col-lg-8'
      open={true}
      toggle={closeModal}
      modalClassName='modal'
      fade={true}
      role='dialog'
    >
      <ModalHeader className='text-dark bg-primary1'>Alert</ModalHeader>
      <ModalBody>
        Hi, there.

        <p>
        We are temporarily suspending our support for <strong>Google and Facebook login</strong> and only allow Email and Password login until further notice.In case if you signed up using Google or Facebook login ealier, please follow the following steps in order to set a password for the NCCC Aduan portal account.
        </p>
        <p>
            <img src={SSOSteps} alt="sso" />
        </p>
        <span>NCCC Team</span>
      </ModalBody>
      <ModalFooter className='home-buttons d-flex w-100 justify-content-between px-3'>
        <Button theme='danger' name='dismiss' onClick={()=> closeModal()}>
          Dismiss
        </Button>
      </ModalFooter>
    </Modal>

    )
}

export default SSORemovelModal
